import React, { Component } from 'react';

import TextInput from '../atoms/TextInput';

export default class Search extends Component {
  state = {
    query: '',
    open: false,
  };

  openDropdown = () => {
    if (this.state.query && this.state.query.trim()) {
      this.setState({ open: true });
    }
  };

  render() {
    return (
      <div className="navbar-item">
        <div className={`dropdown ${this.state.open ? 'is-active' : ''}`}>
          <div className="dropdown-trigger">
            <div className="control has-icons-right">
              <TextInput
                value={this.state.query}
                onChange={(e) => this.setState({ query: e.target.value })}
                onEnterKey={this.openDropdown}
                onBlur={() =>
                  // when the search input loses the focus it can be for two reasons:
                  // 1. the user clicked on a entry on the dropdown => navigate and close the dropdown
                  // 2. the user clicked somewhere else => close the dropdown
                  // While this seems ugly, it is the cleaniest way to achieve a clean closing of the dropdown without
                  // to much listeners scaffolding
                  setTimeout(
                    () => this.setState({
                      open: false,
                      query: '',
                    }),
                    300,
                  )}
              />
              <span className="icon is-small is-right">
                <i className="mi mi-search" />
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Search.displayName = 'Search';
